import DeleteIcon from "@mui/icons-material/Delete";
import { Divider, FormControl, FormControlLabel, IconButton, Radio, RadioGroup } from "@mui/material";
import { styled } from "@mui/material/styles";
import { get } from "lodash";
import React from "react";
import BSInput from "../../../common/js/components/BSInput";

const StyledWrapper = styled("div")({
    display: "flex",
    justifyContent: "space-between",
    gap: "8px",
});

const ExhibitADetail = (props) => {
    const { element, elementIndex, errors, handleUpdateArrayElement, disableInputs, onDelete } = props;

    if (get(element, "exhibitAType", null) == null) {
        handleUpdateArrayElement("exhibitAs", elementIndex, "exhibitAType", "STANDARD");
    }
    return (
        <React.Fragment>
            {disableInputs !== true && (
                <IconButton
                    sx={{ margin: 0, minWidth: 0, padding: 0 }}
                    onClick={() => {
                        onDelete("exhibitAs", elementIndex);
                    }}
                >
                    <DeleteIcon />
                </IconButton>
            )}

            <StyledWrapper>
                <StyledWrapper style={{ minWidth: "50%", marginTop: "15px", marginBottom: "25px" }}>
                    <FormControl rowcomponent="fieldset">
                        <RadioGroup
                            row
                            aria-label="exhibitAType"
                            name="exhibitAType"
                            value={element ? element.exhibitAType : null}
                            onChange={(e) =>
                                handleUpdateArrayElement("exhibitAs", elementIndex, e.target.id, e.target.value)
                            }
                        >
                            <FormControlLabel
                                value="STANDARD"
                                control={
                                    <Radio
                                        id="exhibitAType"
                                        color="primary"
                                        checked={element.exhibitAType === "STANDARD"}
                                    />
                                }
                                style={{ marginRight: "83px" }}
                                label="Standard"
                            />
                            <FormControlLabel
                                value="PREFERENTIAL"
                                control={
                                    <Radio
                                        id="exhibitAType"
                                        color="primary"
                                        checked={element.exhibitAType === "PREFERENTIAL"}
                                    />
                                }
                                label="Preferential"
                            />
                        </RadioGroup>
                    </FormControl>
                </StyledWrapper>
            </StyledWrapper>

            <StyledWrapper>
                <BSInput
                    id="baseSplitPercentage"
                    label="BASE SPLIT %"
                    value={element?.baseSplitPercentage ?? null}
                    error={get(errors, `exhibitAs.${elementIndex}.baseSplitPercentage`, null)}
                    onChange={(e) => handleUpdateArrayElement("exhibitAs", elementIndex, e.target.id, e.target.value)}
                    errorText="Required"
                    endAdornment="%"
                    numeric
                    extraFormControlStyles={{ flex: "0.3 1 0" }}
                    helperText="Required"
                />
                <BSInput
                    id="annualGrossMinimum"
                    label="ANNUAL GROSS MINIMUM $"
                    value={element.annualGrossMinimum !== 0 ? element.annualGrossMinimum : 0}
                    error={get(errors, `exhibitAs.${elementIndex}.annualGrossMinimum`, null)}
                    onChange={(e) => handleUpdateArrayElement("exhibitAs", elementIndex, e.target.id, e.target.value)}
                    errorText="Required"
                    startAdornment="$"
                    numeric
                    extraFormControlStyles={{ flex: "1 1 0" }}
                    helperText="Required"
                />
                <BSInput
                    id="adjustedPercentage"
                    label="ADJUSTED %"
                    value={element ? element.adjustedPercentage : null}
                    error={get(errors, `exhibitAs.${elementIndex}.adjustedPercentage`, null)}
                    onChange={(e) => handleUpdateArrayElement("exhibitAs", elementIndex, e.target.id, e.target.value)}
                    errorText="Required"
                    endAdornment="%"
                    numeric
                    extraFormControlStyles={{ flex: "0.3 1 0", marginBottom: "0" }}
                    helperText="Required"
                />
            </StyledWrapper>
            <StyledWrapper>
                <BSInput
                    id="exhibitAStartDate"
                    label="START DATE"
                    placeholder="Enter start date"
                    value={element ? element.exhibitAStartDate : null}
                    error={get(errors, `exhibitAs.${elementIndex}.exhibitAStartDate`, null)}
                    onChange={(e) => handleUpdateArrayElement("exhibitAs", elementIndex, e.target.id, e.target.value)}
                    disabled={disableInputs === true}
                    extraFormControlStyles={{ flex: "1 1 0" }}
                    type="date"
                />
                <BSInput
                    id="exhibitAExpirationDate"
                    label="EXPIRATION DATE"
                    placeholder="Enter expiration date"
                    value={element ? element.exhibitAExpirationDate : null}
                    error={get(errors, `exhibitAs.${elementIndex}.exhibitAExpirationDate`, null)}
                    onChange={(e) => handleUpdateArrayElement("exhibitAs", elementIndex, e.target.id, e.target.value)}
                    onFocus={() => props.onExpirationDateFocus?.(elementIndex)}
                    inputProps={{
                        onBlur: () => props.onExpirationDateBlur?.(elementIndex),
                    }}
                    disabled={disableInputs === true}
                    helperText="Required"
                    errorText="Required"
                    extraFormControlStyles={{ flex: "1 1 0", marginBottom: "0" }}
                    type="date"
                />
            </StyledWrapper>

            <BSInput
                id="comments"
                label="COMMENTS"
                placeholder="Enter comments"
                value={element ? element.comments : null}
                multiline
                rows={8}
                margin="normal"
                variant="outlined"
                onChange={(e) => handleUpdateArrayElement("exhibitAs", elementIndex, e.target.id, e.target.value)}
            />

            <Divider />
            <br />
        </React.Fragment>
    );
};

export default ExhibitADetail;
